import { Modal, ProductCard } from "theme"; // Import the theme web component and ProductCard

var KlaviyoBackInStock = class extends HTMLElement {
  constructor() {
    super();

    this.showModalButton = this.querySelector('button[type="button"]');

    if (this.showModalButton.getAttribute('aria-controls')) {
      this.modal = document.getElementById(this.showModalButton.getAttribute('aria-controls'));
    } else {
      this.modal = this.querySelector('dialog');
    }

    this.form = this.modal.querySelector('form');

    this.variantIdInput = this.form.querySelector('[name="variant_id"]');
    this.productTitleInput = this.form.querySelector('[name="product_title"]');
    this.variantTitleInput = this.form.querySelector('[name="variant_title"]');
    this.featuredImage = this.form.querySelector('[name="featured_image"]');
    this.closeButton = this.modal.querySelector('.close-dialog');

    // Initial state check (e.g. on page load)
    this.updateVisibilityFromVariant(window.variant || {
      id: this.variantIdInput.value,
      name: this.productTitleInput.value,
      available: this.dataset.available,
      featured_image: { src: this.featuredImage.value }
    });
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('variant:change', (event) => {
      this.updateVisibilityFromVariant(event.detail.variant);
    });
    this.showModalButton.addEventListener('click', () => {
      this.modal.classList.remove('submitted');
      this.modal.showModal();
    });
    this.form.addEventListener('submit', async (e) => {
      e.preventDefault();

      await this.handleSubmit();
    });
    this.closeButton.addEventListener('click', (e) => {
      this.modal.close(); // click outside
    });

  }

  updateVisibilityFromVariant(variant) {
    if (!variant) return;
    this.dataset.available = variant.available;
    this.variantIdInput.value = variant.id;
    this.productTitleInput.value = variant.name;
    if (variant.featured_image) {
      this.featuredImage.value = variant.featured_image.src;
    }
  }

  async handleSubmit() {
    const email = this.form.querySelector('[name="email"]').value;
    const product_id = this.form.querySelector('[name="product_id"]').value;
    const restock_type = this.form.querySelector('[name="restock_type"]').value;
    const company_id = 'Sjshsj';    // AYM Klaviyo Company Id

    const variant_id = this.variantIdInput.value;
    const product_title = this.productTitleInput.value;
    const featured_image = this.featuredImage.value;

    if (window.klaviyo && window.klaviyo.track) {
      // Identify user (optional but recommended)
      window.klaviyo.identify({ email });

      const variantCompositeId = `$shopify:::$default:::${variant_id}`;
      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                  // You can include other profile attrs if you have them (first_name, last_name, etc.)
                }
              }
            },
            channels: ['EMAIL'] // or ['EMAIL','SMS'] if you also collect SMS
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: variantCompositeId
              }
            }
          }
        }
      };

      try {
        const res = await fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(company_id)}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'revision': '2024-06-15' // required header per docs
            },
            body: JSON.stringify(payload)
          }
        );

        // Klaviyo returns 202 on success with no body
        if (!res.ok && res.status !== 202) {
          const err = await res.json().catch(() => ({}));
          console.warn('Klaviyo BIS subscribe failed', res.status, err);
        }

        console.log('Klaviyo identify and track called');
      } catch (e) {
        console.error('Network error calling Klaviyo BIS subscribe', e);
      }
    }
    this.modal.classList.add('submitted');
  }
};

customElements.define('klaviyo-back-in-stock', KlaviyoBackInStock);


var MarketWelcomePopup = class extends Modal {
  connectedCallback() {
    super.connectedCallback();
    if (this.shouldAppearAutomatically) {
      setTimeout(() => this.show(), this.apparitionDelay);
    }
  }
  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }
  get shouldAppendToBody() {
    return false;
  }
  get shouldAppearAutomatically() {
    const query_override = new URLSearchParams(window.location.search).has('market-popup')
    return !(this.hasAttribute("only-once") && localStorage.getItem("theme:market-popup-appeared") === "true") || query_override;
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      localStorage.setItem("theme:market-popup-appeared", "true");
    }
  }
};
if (!window.customElements.get("market-welcome-popup")) {
  window.customElements.define("market-welcome-popup", MarketWelcomePopup);
}

      

var SizeGuidePopup = class extends HTMLElement {
  connectedCallback() {
    this.triggerButton = this.querySelector('.sizing-chart-modal--link');
    this.modal = this.querySelector('x-modal');

    if (this.triggerButton && this.modal) {
      this.triggerButton.addEventListener('click', async (event) => {
        event.preventDefault();
        this.modal.show();
        await this.loadSizeGuidePage();

      });
    }
  }

  async loadSizeGuidePage() {
    const url = window.location.pathname + '?view=size-guide';

    try {
      // Fetch the URL
      const response = await fetch(url);
      
      if (!response.ok) {
        console.error(`Failed to load size guide from ${url}. Status: ${response.status}`);
        return;
      }

      // Parse the response text
      const htmlText = await response.text();

      // Create a temporary div to parse the HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlText;

      const contentSelector = '#main'
      
      const contentElement = tempDiv.querySelector(contentSelector);
      
      if (!contentElement) {
        console.error('No suitable content found in loaded HTML');
        return;
      }
      // Replace modal content 
      // Use the slot directly for more reliable content placement
      const modalSlot = this.modal.querySelector('.modal-content')
      if (modalSlot) {
        // Clear existing content and append new content
        modalSlot.innerHTML = '';
        modalSlot.appendChild(contentElement);
      } 

    } catch (error) {
      console.error('Error loading size guide:', error);
    }
  }

};

if (!window.customElements.get("size-guide-popup")) {
  customElements.define("size-guide-popup", SizeGuidePopup);
}


const ShopifyChatWidget = class extends HTMLElement {
  constructor() {
    super();


    this.addEventListener('click', function (e) {
      e.preventDefault();
      // have to move the search for the chat widget, as it is loaded at a later time
      this.inbox = document.querySelector('#shopify-chat inbox-online-store-chat');
      this.gorgiouChatBtn = document.querySelector('#chat-button');

      if (!this.inbox && !this.gorgiouChatBtn) {
        return;
      }

      if (this.gorgiouChatBtn) {
        if (GorgiasChat.isOpen()) {
          GorgiasChat.close();
          this.gorgiouChatBtn.style.display = "none";
        } else {
          this.gorgiouChatBtn.style.display = "block";
          GorgiasChat.open();
        }
        return;
      }

      this.inbox.shadowRoot.querySelector('button').click();
      setTimeout(this.setChatCentred(), 100);
    });

  }

  setChatCentred() {
    if (!this.inbox) return;

    this.inbox.style.right = 'unset';
    this.inbox.style.left = '50%';
    this.inbox.style.transform = 'translate(-50%, 50%)';
    this.inbox.style.bottom = '50%';
    this.inbox.style.width = '50vw';
    this.inbox.style.height = '50vh';
  }
}
window.customElements.define("chat-widget", ShopifyChatWidget);


// Add init method to ProductCard prototype
ProductCard.prototype.init = function () {
  this.addVideoPreview();
};

// Add addVideoPreview method to ProductCard prototype
ProductCard.prototype.addVideoPreview = function () {
  if (!this.dataset.videoUrl) {
    return;
  }

  // Find the media element
  const mediaElement = this.querySelector('.product-card__figure');
  if (!mediaElement) {
    console.warn('Media element not found for video preview');
    return;
  }

  // Create video element
  const video = document.createElement('video');
  video.className = 'product-card__video';
  video.muted = true;
  video.loop = true;
  video.playsInline = true;
  video.preload = 'metadata';

  // Create source element
  const source = document.createElement('source');
  source.src = this.dataset.videoUrl;
  source.type = this.dataset.videoMimeType || 'video/mp4';
  video.appendChild(source);

  // Add video to media element
  mediaElement.appendChild(video);

  // Store reference for cleanup
  this._videoElement = video;

  // Setup scroll observer for this video
  this.setupVideoScrollObserver();

  // Check and add swatch behaviour
  this.setupSwatchVideoBehaviour();
};

ProductCard.prototype.setupVideoScrollObserver = function () {
  if (!this._videoElement) return;

  // Create intersection observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;

      if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
        // Video is 25% visible, start playing
        if (video.paused) {
          video.play().then(() => {
            video.classList.add('is-playing');
          }).catch(error => {
            console.warn('Video play failed:', error);
          });
        }
      } else {
        // Video is less than 25% visible, pause
        if (!video.paused) {
          video.pause();
          video.classList.remove('is-playing');
        }
      }
    });
  }, {
    threshold: [0, 0.25, 1],
    rootMargin: '0px'
  });

  // Start observing
  observer.observe(this._videoElement);

  // Store observer for cleanup
  this._videoObserver = observer;
};

ProductCard.prototype.setupSwatchVideoBehaviour = function () {
  const swatches = this.querySelector('.product-card__swatch-list');
  if (!swatches) {
    return;
  }
  swatches.addEventListener('mouseover', (e) => {
    if (!this._videoElement.paused) {
      this._videoElement.pause();
      this._videoElement.classList.remove('is-playing');
    }
  });
  swatches.addEventListener('mouseout', (e) => {
    const toElement = e.relatedTarget;
    if (!toElement || !swatches.contains(toElement)) {
      if (this._videoElement.paused) {
        this._videoElement.play().then(() => {
          this._videoElement.classList.add('is-playing');
        }).catch(error => {
          console.warn('Video play failed:', error);
        });
      }
    }
  });
}

// Override connectedCallback to call init
const originalConnectedCallback = ProductCard.prototype.connectedCallback;
ProductCard.prototype.connectedCallback = function () {
  if (originalConnectedCallback) {
    originalConnectedCallback.call(this);
  }
  this.init(); // Call our custom init method
};

// Store original disconnected callback before overriding
const originalDisconnectedCallback = ProductCard.prototype.disconnectedCallback;

// Add cleanup method for disconnecting observers
ProductCard.prototype.disconnectedCallback = function () {
  // Disconnect video observer
  if (this._videoObserver) {
    this._videoObserver.disconnect();
    this._videoObserver = null;
  }

  // Call original disconnected callback if it exists
  if (originalDisconnectedCallback) {
    originalDisconnectedCallback.call(this);
  }
};

// Also initialize any existing ProductCard elements
function initializeExistingProductCards() {
  const existingCards = document.querySelectorAll('product-card');

  existingCards.forEach((card, index) => {
    if (card.init && typeof card.init === 'function') {
      card.init();
    }
  });
}

// Initialize existing cards immediately if DOM is ready, or when it loads
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeExistingProductCards);
} else {
  initializeExistingProductCards();
}

class SizeGuideDescription extends HTMLElement {
  connectedCallback() {
    this.text = this.querySelector('.size-guide__description-text');
    this.button = this.querySelector('.size-guide__description-toggle');

    if (!this.text || !this.button) {
      return;
    }

    this.button.addEventListener('click', () => this.toggle());
  }

  toggle() {
    const expanded = this.text.classList.toggle('is-expanded');

    this.button.textContent = expanded ? this.button.dataset.lessLabel : this.button.dataset.moreLabel;
    this.button.setAttribute('aria-expanded', expanded);
  }
}

if (!window.customElements.get('size-guide-description')) {
  window.customElements.define('size-guide-description', SizeGuideDescription);
}

class SizeGuideGridOverlay extends HTMLElement {
  connectedCallback() {
    this.grid = this.parentElement;

    if (!this.grid) {
      return;
    }

    this.update = this.update.bind(this);
    this.update();

    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.grid);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  update() {
    const style = getComputedStyle(this.grid);
    const rowSizes = style.gridTemplateRows.split(' ').filter(Boolean).map(parseFloat);
    // Whether the grid is currently laid out in its multi-column state (the
    // section's mobile breakpoint collapses it to a single, auto-flowing column).
    const isMultiColumn = style.gridTemplateColumns.split(' ').filter(Boolean).length > 1;
    const gap = parseFloat(style.getPropertyValue('--size-guide-gap')) || 0;

    this.innerHTML = '';

    if (isMultiColumn) {
      // Columns are always equal-width (`repeat(N, minmax(0, 1fr))`), so their
      // sizes are computed directly from the column count and gap rather than
      // parsed from the browser's computed `grid-template-columns` value.
      const columns = parseInt(style.getPropertyValue('--size-guide-columns'), 10);

      if (columns > 0) {
        const columnWidth = (this.grid.clientWidth - gap * (columns - 1)) / columns;
        const columnSizes = new Array(columns).fill(columnWidth);
        const { starts, lines } = this.getTrackGeometry(columnSizes, gap);

        starts.forEach((start, index) => {
          this.appendBand(start, columnWidth, index);
          this.appendNumber('column', start + columnWidth / 2, index + 1);
        });

        lines.forEach((position) => this.appendLine('column', position));
      }
    }

    if (rowSizes.length && !rowSizes.some(isNaN)) {
      // Row heights are content-driven (not uniform like columns), but the real
      // gap between them still needs to be added back in — the browser's
      // computed row sizes only include the tracks themselves, not the gaps.
      const { starts, lines } = this.getTrackGeometry(rowSizes, gap);

      starts.forEach((start, index) => {
        this.appendNumber('row', start + rowSizes[index] / 2, index + 1);
      });

      lines.forEach((position) => this.appendLine('row', position));
    }
  }

  // Given a list of track sizes and the gap between them, returns each track's
  // start offset plus the full list of boundary lines (outer edges, and the
  // midpoint of the gap between every pair of tracks).
  getTrackGeometry(sizes, gap) {
    const starts = [];
    const lines = [0];
    let position = 0;

    sizes.forEach((size, index) => {
      starts.push(position);
      position += size;

      if (index < sizes.length - 1) {
        lines.push(position + gap / 2);
        position += gap;
      } else {
        lines.push(position);
      }
    });

    return { starts, lines };
  }

  appendBand(position, size, index) {
    const band = document.createElement('span');
    band.className = `size-guide__grid-overlay-band ${index % 2 === 0 ? 'is-even' : 'is-odd'}`;
    band.style.left = `${position}px`;
    band.style.width = `${size}px`;

    this.appendChild(band);
  }

  appendLine(axis, position) {
    const line = document.createElement('span');
    line.className = `size-guide__grid-overlay-line size-guide__grid-overlay-line--${axis}`;
    line.style[axis === 'column' ? 'left' : 'top'] = `${position}px`;

    this.appendChild(line);
  }

  appendNumber(axis, center, number) {
    const label = document.createElement('span');
    label.className = `size-guide__grid-overlay-number size-guide__grid-overlay-number--${axis}`;
    label.style[axis === 'column' ? 'left' : 'top'] = `${center}px`;
    label.textContent = number;

    this.appendChild(label);
  }
}

if (!window.customElements.get('size-guide-grid-overlay')) {
  window.customElements.define('size-guide-grid-overlay', SizeGuideGridOverlay);
}